/**
 * Pins button + pins page deep-link handling.
 *
 * 1. When a "Pins" button is clicked from inside a conversation, we append a
 *    stable anchor id (`#g-chatform-pinned-session-<token>`) to the target
 *    URL so the Pinned Messages page knows which conversation's card to focus.
 *
 * 2. When the Pinned Messages page loads with such a hash in the URL, we
 *    scroll the corresponding `.g-chatform-pinned-single` card into view.
 *
 * The session token is read live from the surrounding `.g-chatform[data-session-token]`
 * (same pattern as clearSession / duplicateSession), so it always reflects the
 * conversation the user is currently in — including roleplay scenario URLs.
 */

const PINS_SESSION_HASH_PREFIX = "g-chatform-pinned-session-";

function isValidToken(token) {
    // Ignore shell placeholders that have not been resolved to a real token yet.
    return !!token && token.indexOf("__SHELL_") === -1;
}

function getActiveSessionToken($button) {
    // Prefer the closest chat form so we capture the right conversation when
    // several forms render on a page (e.g. chat + preview shell).
    const $chatForm = $button.closest(".g-chatform");
    if ($chatForm.length && isValidToken($chatForm.attr("data-session-token"))) {
        return $chatForm.attr("data-session-token");
    }
    // Fall back to the first rendered chat form.
    const $firstVisibleForm = $(".g-chatform:not(.g-chatform-pinned)").first();
    return $firstVisibleForm.length && isValidToken($firstVisibleForm.attr("data-session-token"))
        ? $firstVisibleForm.attr("data-session-token")
        : "";
}

function scrollToPinnedSessionFromHash() {
    const hash = (window.location.hash || "").trim();
    if (!hash.startsWith("#" + PINS_SESSION_HASH_PREFIX)) {
        return;
    }

    const target = document.getElementById(hash.slice(1));
    if (!target) {
        return;
    }

    // Wait for images/async content to settle before scrolling so the target
    // element's final position is measured.
    window.setTimeout(function () {
        const pinnedCard = target.closest(".g-chatform-pinned-single") || target;
        pinnedCard.scrollIntoView({ behavior: "smooth", block: "start" });

        // Remove the hash from the URL after the one-time scroll. This way a
        // page reload doesn't re-scroll to the same card over and over — the
        // deep-link is meant to point at the section only on the first visit.
        if (window.history && window.history.replaceState) {
            const url = window.location.pathname + window.location.search;
            window.history.replaceState(window.history.state, "", url);
        }
    }, 100);
}

/**
 * @param {jQuery} element
 */
export function pinsBtn(element) {
    element.on("click", function (event) {
        event.preventDefault();

        const token = getActiveSessionToken($(this));
        let href = $(this).attr("href");

        if (!href) {
            return;
        }

        // Drop any pre-existing pins hash (e.g. one baked in server-side) so we
        // always build the URL from a clean base and append the live token.
        const hashIndex = href.indexOf("#");
        if (hashIndex !== -1) {
            href = href.slice(0, hashIndex);
        }

        if (token) {
            // Lowercase to match the pins-card id anchors built via
            // strtolower() on the Pinned Messages page (see
            // class-growtype-chat-pinned-messages-shortcode.php).
            href += "#" + PINS_SESSION_HASH_PREFIX + token.toLowerCase();
        }

        window.location.assign(href);
    });
}

export function initPinsDeepLink() {
    scrollToPinnedSessionFromHash();
}
